export enum BooleanEnum {
  TRUE = "true",
  FALSE = "false",
}

export enum SizeEnum {
  SMALL = "small",
  MIDDLE = "middle",
  LARGE = "large",
}

export enum ThemeEnum {
  LIGHT = "light",
  DARK = "dark",
}

export enum DeviceEnum {
  MOBILE = "mobile",
  IPAD = "ipad",
  DESKTOP = "desktop",
  DESKTOP_SM = "desktop_sm",
}

export enum InputTypeEum {
  TEXT = "text",
  PASSWORD = "password",
  OTP = "otp",
  EMAIL = "email",
  NUMBER = "number",
  TEL = "tel",
  URL = "url",
  DATE = "date",
  TIME = "time",
  DATETIME_LOCAL = "datetime-local",
  MONTH = "month",
  WEEK = "week",
  SEARCH = "search",
  COLOR = "color",
}

export enum ChartEnum {
  LINE = "line",
  COLUMN = "column",
  PIE = "pie",
  GAUGE = "gauge",
  DOUGHNUT = "doughnut",
  BAR = "bar",
}

export enum MethodTypeEnum {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

export enum StoreEnum {
  AUTH = "authStore",
  INDICATOR = "indicatorStore",
  APP = "appStore",
  LAYER = "layerStore",
  ZONE_STORE = "zoneStore",
  SL_STORE = "stateLevelStore",
  LGA_STORE = "lgaLevelStore",
  WL_STORE = "wardLevelStore",
  HFL_STORE = "hFLevelStore",
  MONITORING_STORE = "monitoringStore",
  REVITALIZATION = "revitalizationStore",
}

export enum QueryKeys {
  REVITALIZATIONS = "revitalizations",
  REVITALIZATION = "revitalization",
  ZONE = "locationZone",
  STATE = "locationState",
  LGA = "locationLga",
  WARD = "locationWard",
  HF = "hf",
  INDICATOR = "indicator",
  INDICATOR_CATEGORIES = "indicatorCategories",
  BOUNDARY = "boundary",
  LAST_UPDATED = "lastUpdated",
}

export enum ContentType {
  JSON = "application/json",
  FORM = "application/x-www-form-urlencoded",
  MULTIPART = "multipart/form-data",
}

export enum LoggerEnum {
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
  DEBUG = "debug",
}

export enum FilterByEnum {
  DAILY = "daily",
  ALL = "all",
}

export enum PHCQueryKeysEnum {
  STAFF_ACCOMMODATION = "staff_accommodation",
  FUNCTIONAL_POWER = "functional_backup_power",
  LEVEL2_PHC = "functional_l2",
  BHCPF_FUNDED = "bhcpf_impact_funds",
}

export enum VisualizationTypeEnum {
  MAP = "map",
  CHART = "chart",
  GRID = "grid",
}

export enum LocationLevelEnum {
  COUNTRY = "country",
  ZONE = "zone",
  STATE = "state",
  LGA = "lga",
  WARD = "ward",
  HF = "hf",
}
